import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { userAPI } from '../../services/api';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState({ name: '', profileImage: '' });
  const [loadingUser, setLoadingUser] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    const fetchUser = async () => {
      setLoadingUser(true);
      try {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          const parsed = JSON.parse(storedUser);
          const userId = parsed.id || parsed._id;
          if (userId) {
            const response = await userAPI.getUserById(userId);
            if (response && response.user) {
              setUser({
                name: response.user.name || 'Patient',
                profileImage: response.user.profileImage || '',
              });
              // Optionally update localStorage
              localStorage.setItem('user', JSON.stringify({ ...parsed, ...response.user }));
            } else {
              setUser({
                name: parsed.name || 'Patient',
                profileImage: parsed.profileImage || '',
              });
            }
          }
        }
      } catch (err) {
        // fallback to localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          const parsed = JSON.parse(storedUser);
          setUser({
            name: parsed.name || 'Patient',
            profileImage: parsed.profileImage || '',
          });
        }
      } finally {
        setLoadingUser(false);
      }
    };
    fetchUser();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col lg:flex-row">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block lg:w-28 fixed lg:relative top-0 left-0 h-full z-20">
        <Sidebar user={user} loadingUser={loadingUser} />
      </div>

      {/* Mobile Sidebar (controlled by state) */}
      <Sidebar isOpen={sidebarOpen} toggle={toggleSidebar} user={user} loadingUser={loadingUser} />

      {/* Content */}
      <div className="flex-1 flex flex-col lg:ml-0">
        <Header toggleSidebar={toggleSidebar} user={user} loadingUser={loadingUser} />
        <main className="flex-1 overflow-y-auto bg-white">
          <div className="p-8">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
